import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AutomationGroup } from "../types/automation";
import { AUTOMATION_COLLECTIONS_QUERY_KEY } from "./useFetchAutomationCollections";

/**
 * Updates a group in an automation collection.
 * @param id - The automation collection ID.
 * @param groupId - The group ID to update.
 * @param group - The updated group data.
 * @returns The updated automation collection or group, depending on backend response.
 */
const updateAutomationGroup = async ({
  id,
  groupId,
  group
}: {
  id: string;
  groupId: string;
  group: AutomationGroup;
}) => {
  const response = await axios.put(
    `${AUTOMATION_SERVICE_ADDRESS}/automation/${id}/groups/${groupId}`,
    group
  );
  return response.data;
};

export default function useUpdateAutomationGroup() {
  const queryClient = useQueryClient();
  return useMutation(updateAutomationGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_COLLECTIONS_QUERY_KEY);
    }
  });
}
